import '../types';
export function createModule(conf) {
  var stateSelector;

  if (typeof conf.storeKey === 'string') {
    stateSelector = function stateSelector(state) {
      return state[conf.storeKey];
    };
  } else {
    stateSelector = conf.storeKey;
  }

  return {
    stateSelector: stateSelector
  };
}